module.exports = __webpack_public_path__ + "975f0e930c6ae70497cc1d1a13d0ec8d.jpg";